<template>
    <ul class="sidebarChallenges">
      <h2>{{content.firstPart.mainTitle}}</h2>
      <li v-for="menu in content.firstPart.buttons" :key="menu.text">
        <b-button class="bt btn-browse" :to="menu.link">
            <span>
                <font-awesome-icon :icon="[menu.iconType, menu.iconName]" />
            </span>
            {{menu.text}}
        </b-button>  
      </li>

      <div class="sep"></div>
      <div class="title">
        <h2>{{content.secondPart.mainTitle}}</h2>
        <div class="target green">
          {{content.secondPart.etiquette}}
        </div>
      </div>

      <div class="select__wrapper">
        <font-awesome-icon :icon="['far', 'chevron-down']" />
        <b-form-select v-model="selected" :options="options" class="select">
        </b-form-select>
      </div>


      <li v-for="menu in content.secondPart.buttons" :key="menu.text" >
          <b-button class="bt btn-icon" :to="menu.link">
            <div class="left">
              <span>
                <font-awesome-icon :icon="[menu.iconType, menu.iconName]" />
              </span>
              <p> {{menu.text}}</p>
            </div>
              <div class="target" v-if="menu.notifications">{{menu.notifications}}</div>
          </b-button>
      </li>
      <br><br>
      
      <li v-for="menu in content.threePart.buttons" :key="menu.text" >
        <b-button class="bt btn-red" :to="menu.link">
            <span>
                <font-awesome-icon :icon="[menu.iconType, menu.iconName]" />
            </span>
            {{menu.text}}
        </b-button>  
      </li>

    
    </ul>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: "SidebarChallenges",

  components: {
  },
  
  data() {
    return {
       content:{},
       selected: null,
        options: [
          { value: null, text: 'Please select an option' },
          { value: 'a', text: 'This is First option' },
          { value: 'b', text: 'Selected Option' },
          { value: { C: '3PO' }, text: 'This is an option with object value' },
          { value: 'd', text: 'This one is disabled', disabled: true }
        ]        
    }
  },
  computed: {
    ...mapGetters([
      'getSideChallenges',
    ]),
  },
  created (){
    this.content = this.getSideChallenges;
  },
  methods: {
  }
}
</script>